export const MOBILE_BREAKPOINT_FOR_LOGIN_SCREEN_ONLY = 768;
